import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/charts/styles.css";
import "@mantine/notifications/styles.css";
import "./i18n-setup";
import { DehubThemeProvider, ModalsProvider, Notifications } from "@dehub/theme";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { persistor, store } from "./store";
import "./styles/base.css";

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log("Service Worker registered:", registration);
    })
    .catch((error) => {
      console.error("Service Worker registration failed:", error);
    });
}

const themeOverride = {
  components: {
    // Canvas: selected chips and the active page are dark; brand red is reserved for the primary create action.
    Chip: {
      defaultProps: { color: "dark", variant: "filled" },
      styles: { iconWrapper: { display: "none" }, label: { paddingInline: "var(--mantine-spacing-md)" } },
    },
    Pagination: {
      defaultProps: { color: "dark" },
    },
    // Selected values render as Pills at 12px by default; text stays at 14px.
    Pill: {
      styles: { root: { fontSize: "var(--mantine-font-size-sm)" } },
    },
    Tabs: {
      defaultProps: { color: "dark" },
    },
    Switch: {
      defaultProps: { color: "dark" },
    },
    Breadcrumbs: {
      styles: {
        breadcrumb: {
          color: "var(--mantine-color-gray-7)",
          fontSize: 14,
        },
      },
    },
  },
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter basename={(window as any).__BASE_PATH__ || ""}>
          <DehubThemeProvider themeOverride={themeOverride} colorAliases={{ cyan: "brand" }}>
            <ModalsProvider>
              <Notifications position="top-right" />
              <App />
            </ModalsProvider>
          </DehubThemeProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);

reportWebVitals();
